import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "max-w-[1040px]" }
const _hoisted_2 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_3 = { class: "flex justify-end shrink-0" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "text-gray-900 font-medium truncate" }
const _hoisted_6 = { class: "truncate" }
const _hoisted_7 = { class: "flex justify-end shrink-0" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm"
}

import { Bars3Icon, LockClosedIcon, XCircleIcon } from '@heroicons/vue/24/outline'
import Sortable from 'sortablejs'
import { computed, onMounted, ref, watch } from 'vue'

import FranchiseLockNotice from '@/components/franchise/FranchiseLockNotice.vue'
import EmptyState from '@/components/neue/EmptyState'
import FormElement from '@/components/neue/FormElement'
import FormSection from '@/components/neue/FormSection'
import InputField from '@/components/neue/InputField'
import NeueButton from '@/components/neue/NeueButton'
import NeueLoading from '@/components/neue/NeueLoading'
import NeueTablist from '@/components/neue/NeueTablist'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import TablistHeader from '@/components/neue/TablistHeader'
import TablistRow from '@/components/neue/TablistRow'
import { franchiseRecordLockText, isFranchiseManaged } from '@/helpers/franchiseManaged'
import api from '@/store/api'
import { mapRelationship, mapRelationships } from '@/store/mappers'


export default {
  __name: 'StoreCategories',
  props: ['id'],
  setup(__props) {

const loading = ref(true)
const props = __props
const store = computed(() => mapRelationship({ type: 'store', id: props.id }))

const modal = ref({ open: false })

const cols = [{ width: 'minmax(180px, 2fr)' }, { width: 'minmax(160px, 1fr)' }, { width: '120px' }]

const minimumLabel = count => (count ? `${count} item${count === 1 ? '' : 's'}` : 'No minimum')

const rows = ref(null)

watch(rows, () => {
  if (rows.value)
    new Sortable(rows.value, {
      handle: '.cursor-move',
      ghostClass: 'bg-gray-200',
      dragClass: 'bg-white',
      onSort(e) {
        const list = categories.value
        const moved = list.splice(e.oldIndex, 1)[0]
        list.splice(e.newIndex, 0, moved)
        api.call('PUT', `stores/${props.id}`, {
          store: {
            categories_attributes: list.map((x, i) => ({
              id: x.id,
              order_value: i
            }))
          }
        })
      }
    })
})

onMounted(async () => {
  await api.call('GET', `stores/${props.id}/categories?included=none`)
  loading.value = false
})

const categories = computed(() =>
  mapRelationships(store.value?.relationships.categories.data)
    .filter(x => x.attributes.type !== 'UpsellCategory')
    .sort((a, b) => a.attributes.order_value - b.attributes.order_value)
)

const addCategory = () => {
  modal.value = {
    open: true,
    mode: 'add',
    name: '',
    description: '',
    minimumItems: 0
  }
}

const editCategory = category => {
  modal.value = {
    open: true,
    mode: 'edit',
    category,
    // Every field here is the franchise's on a managed category, so the modal only shows them.
    managed: isFranchiseManaged(category),
    franchiseName: category.attributes.franchise_name ?? null,
    name: category.attributes.category_name,
    description: category.attributes.category_description,
    minimumItems: category.attributes.minimum_items_count
  }
}

const saveModal = () => {
  if (modal.value.managed) return
  let action, url
  if (modal.value.mode === 'add') {
    action = 'POST'
    url = `stores/${props.id}/categories`
  } else if (modal.value.mode === 'edit') {
    action = 'PUT'
    url = `stores/${props.id}/categories/${modal.value.category.id}`
  }

  api.call(action, url, {
    category: {
      category_name: modal.value.name,
      category_description: modal.value.description,
      minimum_items_count: modal.value.minimumItems
    }
  })

  modal.value.open = false
}

const deleteCategory = category => {
  if (isFranchiseManaged(category)) return
  if (!confirm(`Delete ${category.attributes.category_name}?`)) return
  api.call('DELETE', `stores/${props.id}/categories/${category.id}`, {}, { delete: false })
}

return (_ctx, _cache) => {
  const _component_InputArea = _resolveComponent("InputArea")
  const _component_TheModal = _resolveComponent("TheModal")
  const _directive_tippy = _resolveDirective("tippy")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(NeueLoading), { loading: loading.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(SettingsSection, {
            title: "Your categories",
            description: "Categories group products on the selection screen, like Breakfast, Lunch or Snacks. Drag to reorder them - customers see them in this order. Give a category a minimum quantity to require that many items from it before checkout.",
            plain: ""
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(NeueTablist), null, {
                  head: _withCtx(() => [
                    _createVNode(_unref(TablistHeader), null, {
                      default: _withCtx(() => [
                        _createVNode(TablistGrid, {
                          columns: cols,
                          header: "",
                          class: "items-center"
                        }, {
                          default: _withCtx(() => [
                            _cache[8] || (_cache[8] = _createElementVNode("div", null, "Name", -1)),
                            _cache[9] || (_cache[9] = _createElementVNode("div", null, "Minimum quantity", -1)),
                            _createElementVNode("div", _hoisted_3, [
                              _createVNode(_unref(NeueButton), {
                                type: "secondary",
                                class: "whitespace-nowrap",
                                onClick: addCategory
                              }, {
                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                  _createTextVNode("+ Category", -1)
                                ]))]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      ref_key: "rows",
                      ref: rows,
                      class: "divide-y divide-gray-200"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
                        return (_openBlock(), _createBlock(_unref(TablistRow), {
                          key: category.id,
                          "data-category-id": category.id,
                          class: "cursor-pointer",
                          onClick: $event => (editCategory(category))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(TablistGrid, {
                              columns: cols,
                              class: "items-center"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["-ml-4 px-3 -mt-2 -mb-2 py-2", _unref(isFranchiseManaged)(category) ? 'invisible' : 'cursor-move']),
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    _createVNode(_unref(Bars3Icon), { class: "h-5 w-5" })
                                  ], 2),
                                  _createElementVNode("span", _hoisted_5, _toDisplayString(category.attributes.category_name), 1)
                                ]),
                                _createElementVNode("div", _hoisted_6, _toDisplayString(minimumLabel(category.attributes.minimum_items_count)), 1),
                                _createElementVNode("div", _hoisted_7, [
                                  (_unref(isFranchiseManaged)(category))
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        "data-test": "category-lock",
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                                      }, [
                                        _createVNode(_unref(LockClosedIcon), { class: "h-6 w-6 shrink-0 text-gray-400" })
                                      ])), [
                                        [_directive_tippy, { content: _unref(franchiseRecordLockText)(category) }]
                                      ])
                                    : (_openBlock(), _createElementBlock("span", {
                                        key: 1,
                                        "data-test": "delete-category",
                                        onClick: _withModifiers($event => (deleteCategory(category)), ["stop"])
                                      }, [
                                        _createVNode(_unref(XCircleIcon), { class: "cursor-pointer h-6 w-6 hover:text-black shrink-0" })
                                      ], 8, _hoisted_8))
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["data-category-id", "onClick"]))
                      }), 128))
                    ], 512)
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, categories.value.length]
              ]),
              (!categories.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_unref(EmptyState), { plural: "categories" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NeueButton), {
                          type: "secondary",
                          onClick: addCategory
                        }, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createTextVNode("+ Category", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_component_TheModal, {
      "is-open": modal.value.open,
      "modal-title": modal.value.mode === 'add' ? 'Add category' : 'Edit category',
      onCloseModal: _cache[6] || (_cache[6] = $event => (modal.value.open = false))
    }, {
      main: _withCtx(() => [
        (modal.value.managed)
          ? (_openBlock(), _createBlock(FranchiseLockNotice, {
              key: 0,
              "franchise-name": modal.value.franchiseName
            }, null, 8, ["franchise-name"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(FormSection), null, {
          default: _withCtx(() => [
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_unref(InputField), {
                  modelValue: modal.value.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((modal.value.name) = $event)),
                  name: "Name",
                  disabled: modal.value.managed
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_component_InputArea, {
                  modelValue: modal.value.description,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((modal.value.description) = $event)),
                  name: "Description",
                  disabled: modal.value.managed
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_unref(InputField), {
                  modelValue: modal.value.minimumItems,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((modal.value.minimumItems) = $event)),
                  name: "Minimum quantity of products required in this category to allow checkout",
                  prefix: "#",
                  disabled: modal.value.managed
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(NeueButton), {
          type: "secondary",
          onClick: _cache[5] || (_cache[5] = $event => (modal.value.open = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(modal.value.managed ? 'Close' : 'Cancel'), 1)
          ]),
          _: 1
        }),
        (!modal.value.managed)
          ? (_openBlock(), _createBlock(_unref(NeueButton), {
              key: 0,
              type: "primary",
              onClick: saveModal
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("Save", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-open", "modal-title"])
  ], 64))
}
}

}